
export function isJSBlock(data: any): boolean {
  return data && data.type === 'JSBlock';
}
